import { gql, useFragment } from '@apollo/client';

/**
 * De quién es un recorrido, leído de la caché (2026-09-23).
 *
 * Lo necesita el lápiz de EDITAR el recorrido, que desde hoy mira equipo y
 * dueño para el Tablet (`canEditSurveillanceRoute`). Dos de sus tres puntos de
 * entrada —la card gemela y la fila del listado— no tienen el recorrido entero
 * a mano, pero la caché sí: el loader del detalle y el del listado lo acaban de
 * traer. Reactivo: si el sondeo del cronómetro trae otro dueño, el lápiz se
 * entera sin recargar.
 *
 * `undefined` mientras no se sepa el equipo y el estado: el Tablet no ve el
 * lápiz hasta saber de quién es, que es el lado seguro. `timerOwnerId` NO se
 * exige: ausente es «sin dueño», igual que lo lee `canOperateTimer`, y un
 * recorrido cacheado antes de que existiera el campo no debe quedarse sin
 * lápiz para su propio equipo.
 */
const ROUTE_OWNERSHIP = gql`
  fragment SurveillanceRouteOwnership on SurveillanceRoute {
    id
    state
    teamIDs
    timerOwnerId
  }
`;

export type RouteOwnership = {
  state?: string | null;
  teamIDs?: string[] | null;
  timerOwnerId?: string | null;
};

export const useSurveillanceRouteOwnership = (
  routeId: string | null | undefined
): RouteOwnership | undefined => {
  const { data } = useFragment<RouteOwnership>({
    fragment: ROUTE_OWNERSHIP,
    from: { __typename: 'SurveillanceRoute', id: routeId ?? '' },
  });
  if (!routeId || !data?.state || !Array.isArray(data.teamIDs)) return undefined;
  const teamIDs: string[] = [];
  for (const id of data.teamIDs) if (typeof id === 'string') teamIDs.push(id);
  return { state: data.state, teamIDs, timerOwnerId: data.timerOwnerId ?? null };
};

export default useSurveillanceRouteOwnership;
